import * as dateFns from 'date-fns'

export const formatDate = (date: Date, format: string) => {
  return dateFns.format(date, format)
}

export const getTomorrowDate = () => {
  return dateFns.addDays(new Date(), 1)
}

export const getDateAtHour = (date: Date, hourIn24HrFormat: number) => {
  const newDate = dateFns.setHours(date, hourIn24HrFormat)
  newDate.setMinutes(0)
  newDate.setSeconds(0)
  newDate.setMilliseconds(0)
  return newDate
}

export const addHoursToDate = (date: Date, hours: number) => {
  return dateFns.addHours(date, hours)
}

export const parseDateFromString = (dateString: string, format: string) => {
  return dateFns.parse(dateString, format, new Date())
}
